import * as React from 'react';
import {History} from 'history';
import classnames from 'classnames';
import NavigationLink from '../partials/NavigationLink';
import {logger} from '../../utils/bi';
import {Route} from '../../routes/navigation';
import s from './List.scss';

type ListProps = {
  history: History;
  itemHooks?: string;
  itemClassName?: string;
  items: Route[];
  className?: string;
  behaviour?: 'list' | 'dropdown';
};

interface ListState {
  open: boolean;
}

const openEvents = ['focusin', 'mouseenter'];
const closeEvents = ['focusout', 'mouseleave'];

export class List extends React.Component<ListProps, ListState> {
  state = {open: false};
  listRef: HTMLUListElement;

  getBehaviour() {
    return this.props.behaviour || 'list';
  }

  componentWillUnmount() {
    if (this.getBehaviour() === 'dropdown') {
      openEvents.forEach(eventName => {
        this.listRef.parentElement.removeEventListener(eventName, this.handleEnter);
      });
      closeEvents.forEach(eventName => {
        this.listRef.parentElement.removeEventListener(eventName, this.handleLeave);
      });
      document.removeEventListener('touchstart', this.handleTouchStart);
    }
  }

  componentDidMount() {
    if (this.getBehaviour() === 'dropdown') {
      openEvents.forEach(eventName => {
        this.listRef.parentElement.addEventListener(eventName, this.handleEnter);
      });
      closeEvents.forEach(eventName => {
        this.listRef.parentElement.addEventListener(eventName, this.handleLeave);
      });
      document.addEventListener('touchstart', this.handleTouchStart);
    }
  }

  handleTouchStart = (e: TouchEvent) => {
    const touchedEl = e.target as Element;
    const dropDownWrapper = this.listRef.parentElement;

    if (touchedEl === dropDownWrapper || dropDownWrapper.contains(touchedEl)) {
      this.open();
    } else {
      this.close();
    }
  }

  handleEnter = (e: FocusEvent | MouseEvent) => {
    this.open();
  }

  handleLeave = (e: FocusEvent | MouseEvent) => {
    const elementMovedTo = e.relatedTarget as Element;
    const dropDownWrapper = e.currentTarget as Element;

    if (e.type === 'focusout' && dropDownWrapper.contains(elementMovedTo)) {
      return;
    }

    this.close();
  }

  open = () => this.setState({open: true});

  close = () => this.setState({open: false});

  setListRef = (ref: HTMLUListElement) => this.listRef = ref;

  handleOnClick = (buttonLabel: string) => {
    logger({
      evid: 334,
      button_name: buttonLabel.toLowerCase(),
      location: 'side bar'
    });

    if (this.getBehaviour() === 'dropdown') {
      this.close();
    }
  }

  render() {
    const {items, itemHooks, className, itemClassName} = this.props;
    const {open} = this.state;
    const isDropDown = this.getBehaviour() === 'dropdown';
    const classes = classnames({
      [className]: true,
      [s.dropDown]: isDropDown,
      [s.dropDownOpen]: isDropDown && open,
    });

    return (<ul className={classes} ref={this.setListRef}>
      {items.map((link, index) => (
        <NavigationLink
          key={index}
          link={link}
          className={itemClassName}
          data-hooks={itemHooks}
          onClickHandler={this.handleOnClick}
        />
      ))
      }
      {this.props.children}
    </ul>);
  }
}
